import { render, staticRenderFns } from "./Aside-Main.vue?vue&type=template&id=4cb9b172&"
import script from "./Aside-Main.vue?vue&type=script&lang=js&"
export * from "./Aside-Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports